import * as React from "react";
import type { SVGProps } from "react";
const SvgWatch01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="m7.625 16.982 1.12 4.256c.056.213.25.362.47.362h5.345c.212 0 .4-.138.464-.34l1.35-4.278m0-9.964-1.12-4.256a.486.486 0 0 0-.47-.362H9.44c-.212 0-.4.137-.464.34l-1.35 4.278m10.936 4.86a6.562 6.562 0 1 1-13.124 0 6.562 6.562 0 0 1 13.124 0Z"
    />
  </svg>
);
export default SvgWatch01;
